import { useEffect } from "react";
import { useBloc as useBlocNext } from "@blac/react";
import AuthenticationBloc from "../UserCubit/AuthenticationBloc";
import UserCubit from "../UserCubit/UserCubit";
import { useBloc } from "../state";
import { AuthStage } from "src/types/auth";

export default function useUserAuthStage(): AuthStage {
  const [{ authStage }, { updateAuthStage }] = useBlocNext(AuthenticationBloc);
  const [{ userData }] = useBloc(UserCubit);

  useEffect(() => {
    void updateAuthStage();
  }, [
    userData?.passwordSet,
    userData?.email,
    userData?.sessionAuthenticationMethod
  ]);
  return authStage;
}
